import { createAsyncThunk } from '@reduxjs/toolkit';

import { axiosInstance } from '@/shared/api/instance';
import type { IRole } from '../api/roles.types';
import type { ApiError } from '@/features/events/api/events.types';

const preloadImages = (roles: IRole[]) => {
  roles.forEach((role) => {
    if (role.images.male) {
      const img = new Image();
      img.src = role.images.male;
    }
    if (role.images.female) {
      const img = new Image();
      img.src = role.images.female;
    }
  });
};

export const fetchRoles = createAsyncThunk<IRole[], void, { rejectValue: ApiError }>(
  'roles/fetchRoles',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get<IRole[]>('/app/roles');
      preloadImages(data);
      return data;
    } catch (error: any) {
      const defaultError = {
        code: 500,
        message: 'Unknown error occurred',
      };

      if (!error.response) {
        return rejectWithValue({
          code: 503,
          message: 'Network error - server unavailable',
        });
      }

      return rejectWithValue({
        code: error.response.status || defaultError.code,
        message: error.response.data?.message || defaultError.message,
      });
    }
  },
);

export const buyRole = createAsyncThunk<{ id: string }, string, { rejectValue: ApiError }>(
  'roles/buyRole',
  async (roleMachineName, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(`/app/purchases/buy-role?role=${roleMachineName}`);
      return data;
    } catch (error: any) {
      const defaultError = {
        code: 500,
        message: 'Unknown error occurred',
      };

      if (!error.response) {
        return rejectWithValue({
          code: 503,
          message: 'Network error - server unavailable',
        });
      }

      return rejectWithValue({
        code: error.response.status || defaultError.code,
        message:
          error.response.data?.description || error.response.data?.message || defaultError.message,
      });
    }
  },
);
